import StepCompletionLink from '@cohort/merchants/apps/common/triggers/StepCompletionLink';
import {TIKTOK_URL} from '@cohort/shared/apps/tiktok/common';
import type {TikTokRepostTiktokVerificationAttemptData} from '@cohort/shared/apps/tiktok/triggers/repostTiktok';
import {Trans} from 'react-i18next';

const TikTokRepostTiktokTriggerStepCompletionTitleComponent: React.FC<{
  data: TikTokRepostTiktokVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data}) => {
  const userLink = `${TIKTOK_URL}/@${data.username}`;

  return (
    <Trans
      i18nKey="triggers.repost-tiktok.stepCompletionTitleComponent.success"
      ns="app-tiktok"
      values={{username: data.username}}
      components={{
        userLink: <StepCompletionLink url={userLink} />,
        tiktokLink: <StepCompletionLink url={data.url} />,
      }}
    />
  );
};

export default TikTokRepostTiktokTriggerStepCompletionTitleComponent;
